// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { SELECTORS } from "@Redux";
import { useSelector } from "react-redux";

const useTrustIcons = () => {
    const hostData = useSelector(SELECTORS.hostData);

    const event = useSelector(SELECTORS.event);
    const { list: eventList, selectedEvent } = event;
    const eventData = eventList[selectedEvent!];

    return {
        hideTrustmarkerIcons: hostData?.hide_trustmarker_icons,
        eventData,
    };
};

export default useTrustIcons;
